import React, { useEffect, useState } from "react";
import styles from "./Footer.module.css";
import axios from "axios";
import ExternalLink from "../links/externalLink/ExternalLink";
import { apiUrl } from "../../constants";

// Here we request the information for the footer
function Footer() {
  const [contacts, setContacts] = useState([]);

  // When the page is loaded we get the contact information from the database.
  useEffect(() => {
    async function getData() {
      try {
        const { data } = await axios.get(`${apiUrl}/specsheets/contact`);
        setContacts(data[0].contact);
      } catch (e) {
        console.error(e);
      }
    }

    getData();
  }, []);

  return (
    <div className={styles["blue-container"]}>
      <div className={styles.footer}>
        <div className={styles["top-container"]}>
          <div className={styles["logo-contact-wrapper"]}>
            <svg className={styles["w-logo"]}>
              <g style={{ fill: "#c1002a" }}>
                <g data-name="weborama w">
                  <path
                    d="M54,939.75a2.56,2.56,0,0,1-2.23,1.54H46.27a2.54,2.54,0,0,1-2.21-1.55l-2.4-6.5c-0.31-.85-0.81-0.85-1.12,0l-2.29,6.48a2.5,2.5,0,0,1-2.19,1.55H30.52a2.61,2.61,0,0,1-2.25-1.53l-5.75-14.6a1,1,0,0,1,1-1.53h3.88a2.42,2.42,0,0,1,2.15,1.57l3.13,9.67c0.28,0.86.77,0.87,1.08,0l3.64-9.71a2.56,2.56,0,0,1,2.22-1.54h2.8a2.55,2.55,0,0,1,2.22,1.55l3.61,9.71c0.32,0.85.8,0.84,1.07,0l3.05-9.66a2.4,2.4,0,0,1,2.14-1.57h3.88a1.06,1.06,0,0,1,1.06,1.54Z"
                    transform="translate(-22.41 -918.3)"
                  />
                </g>
              </g>
            </svg>
          </div>

          <div className={styles["contact-container"]}>
            <p className={styles.contact}>Contact Support</p>
            <div className={styles["contact-box"]}>
              {contacts &&
                contacts.map((contact) => {
                  return (
                    <ul key={contact.country}>
                      <li>{contact.country}</li>
                      <li>{contact.email}</li>
                      <li>{contact.telephone}</li>
                    </ul>
                  );
                })}
            </div>
          </div>

          <p className={styles.copyright}>
            Copyright © {new Date().getFullYear()} &nbsp;
            <span>
              <ExternalLink
                link="https://www.weborama.nl/"
                children="Weborama Nederland"
              />
            </span>
            . All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
